export const SurveySessionCodes = {
  SURVEY_ALREADY_COMPLETED_CODE: 'SURVEY_ALREADY_COMPLETED',
  SURVEY_SUPERSEDED_CODE: 'SURVEY_SUPERSEDED',
  REQUEST_EXPIRED_CODE: 'REQUEST_EXPIRED',
} as const;

export const SurveySessionMessages = {
  SURVEY_ALREADY_COMPLETED_MESSAGE: 'Survey has already been completed.',
  SURVEY_SUPERSEDED_MESSAGE: 'This survey has been replaced with a newer version.',
  INSURANCE_ALREADY_SUBMITTED_MESSAGE: 'Insurance has already been submitted.',
  REQUEST_EXPIRED_MESSAGE: 'This request is no longer available.',
} as const;
